export const version = "transactions/5.0.7";
//# sourceMappingURL=_version.js.map